import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {

} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Set a component's draft flow nodes and links
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestSetComponentFlow = packet => {
  return {
    type: 'REQUEST_SET_COMPONENT_FLOW',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveSetComponentFlowSuccess = data => ({
  type: 'RECEIVE_SET_COMPONENT_FLOW_SUCCESS',
  data
})

export const receiveSetComponentFlowFail = data => ({
  type: 'RECEIVE_SET_COMPONENT_FLOW_FAIL',
  data
})

export const tryToSetComponentFlow = packet => (dispatch, getState) => {

  dispatch(requestSetComponentFlow(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;
  return fetch('/api/components/draft/flow/' + packet.id, {
      method: 'put',
      body: JSON.stringify(packet),
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveSetComponentFlowSuccess(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveSetComponentFlowFail({errors:e, lastSubmit: packet}));
    })
}
